module.exports = __webpack_public_path__ + "img/44.d2f58876.png";